import Button from '@mui/material/Button'
import { useFormContext } from '../core/context'

export interface SubmitFieldProps {
  value?: string
  label?: string
  disabled?: boolean
  [key: string]: unknown
}

export function SubmitField({ value, label, disabled: disabledProp, ...rest }: SubmitFieldProps) {
  const { disabled, submitting, errors } = useFormContext()
  const buttonText = label ?? value ?? 'Submit'
  const hasErrors = errors.length > 0

  return (
    <Button
      type="submit"
      variant="contained"
      disabled={disabledProp || disabled || submitting || hasErrors}
      {...rest}
    >
      {submitting ? 'Submitting…' : buttonText}
    </Button>
  )
}
